import {
  Inject,
  Injectable,
} from 'ng-metadata/core';

import { ApiService } from 'services/api.service';

@Injectable()
export class CurrencyService extends ApiService {

    /**
   * Get list of countries
   * country.label {string} Full name of country
   * country.value {string} Country ISO code
   */
  async getRate(iso_from: string, iso_to: string) {
    try {
      const response: any = await this.getRequest(`/support/currency/convert/${iso_from}/${iso_to}`);
      
      return response.data;
    } catch(e) {
      throw e
    }
  }

  /**
   * Get list of USA states
   * state.label {string} Full name of state
   * state.value {string} State ISO code
   */
  async getCurrencyHistory(iso_from: string, iso_to: string) {
    try {
      const response: any = await this.getRequest(`/support/currency/history/${iso_from}/${iso_to}`);

      return response.data;
    } catch (e) {
      throw e
    }
  }
}


// WEBPACK FOOTER //
// ./resources/assets/js/services/currency.service.ts